import { PortfolioCompanyDetailScreen } from "@civala/investor-nexus-pitch"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/companies/$id/")({
  component: PortfolioCompanyDetailScreen,
})
